import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import UnityPriseRepository from '@/shared/http/repositories/realestate/unitytype'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Colapsetower',
  props: ['i', 'name', 'dataTable', 'status', 'countapr', 'dataGroup', 'dataType', 'dataEnterprise'],
  data () {
    return {
      changeAngel: false,
      dataEdit: [],
      options: [
        { item: 'A', name: 'Option A' }
      ],
      getNotStatusData: [],
      notGroup: [],
      notType: [],
      newPlant: false,
      namePlant: '',
      btnNewPlant: true
    }
  },
  watch: {
    namePlant (newValue, oldValue) {
      if (newValue !== '') {
        this.btnNewPlant = false
      } else {
        this.btnNewPlant = true
      }
    }
  },
  methods: {
    abrirNovaPlanta () {
      this.$refs.authmodalNew.show()
    },
    fecharNovaPlanta () {
      this.$refs.authmodalNew.hide()
    },
    getStatus (id) {
      let status = this.status.find((Element) => Element.enum === id)
      return status.descricao
    },
    edit (obj) {
      Object.assign(this.dataEdit, obj)
      this.namePlant = ''
      this.newPlant = false
      this.getNotStatus(this.dataEdit.disponibilidade)
      this.dataEdit.statusSelecionado = this.getStatuDescricao(this.dataEdit.disponibilidade)
      this.getNotGroup(this.dataEdit.grupo)
      this.getNotInyType(this.dataEdit.unidadeTipo.id)
      this.$refs.authmodal.show()
    },
    getStatuDescricao (int) {
      if (this.status.length > 1 && int !== undefined) {
        let status = this.status.find((Element) => Element.enum === int)
        return status.descricao
      }
    },
    getNotStatus (int) {
      if (this.status.length > 0) {
        this.getNotStatusData = this.status.filter((Element) => Element.enum !== int)
      }
    },
    savetype () {
      loading.push()
      let data = {
        Nome: this.namePlant
      }
      UnityPriseRepository.NewType(this.dataEnterprise.id, data)
        .then(Response => {
          this.notType.push(Response.data)
          loading.pop()
          this.newPlant = false
        })
        .catch(Error => {
          loading.pop()
        })
    },
    changePlant (e) {
      let dados = this.notType.find((Element) => Element.id === e.target.value)
      this.dataEdit.unidadeTipo.suites = dados.suites
      this.dataEdit.unidadeTipo.metragem = dados.metragem
    },
    getNotGroup (group) {
      if (this.dataGroup.length > 0) {
        this.notGroup = this.dataGroup.filter((Element) => Element.group !== group)
      }
    },
    getNotInyType (id) {
      if (this.dataType.length > 0) {
        this.notType = this.dataType.filter((Element) => Element.id !== id)
      }
    },
    saveUnity () {
      loading.push()
      let data = {
        Grupo: this.dataEdit.grupo,
        Id: this.dataEdit.id,
        UnidadeTipoId: this.dataEdit.unidadeId,
        Posicao: this.dataEdit.posicao,
        Disponibilidade: this.dataEdit.disponibilidade

      }
      EnterpriseUnityRepository.ChangeUnity(data)
        .then(Response => {
          loading.pop()
          this.$emit('load')
          this.$refs.authmodal.hide()
        })
        .catch(Error => loading.pop())
    },
    closeModal () {
      this.$refs.authmodal.hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/colapsetower/colapsetower.js